const bundles = {
    'ar-SA': {},
    'de-DE': {},
    'en-GB': {},
    'en-US': {
        'teams.webView.appCodeHeader': 'Login',
        'teams.webView.appCodePlaceholder': 'App Code',
        'teams.webView.appCodeContinue': 'Continue',
        'teams.webView.appCodeHelpLink': 'Don\'t have an AppCode?',
        'teams.webView.appCodeHelp': 'Check with your recognition program system administrator for AppCode information, or for additional support ',
        'teams.webView.appCodeHelpSupport': 'click here',
        'teams.webView.appCodeInvalid': 'App Code is Invalid!',
        'teams.webView.loggingInHeader': 'Logging in...',
        'teams.webView.welcomeMessage': 'Please log in. If a log in window did not open, please check your pop-up settings.',
        'teams.webView.connectAccountMessage': 'You must first link your ${integration} account to RecognitionNow.',
        'teams.webView.connectAccountMessage.elevate': 'You must first link your ${integration} account to Elevate.',
        'teams.webView.connectAccountButton': 'Link to RecognitionNow',
        'teams.webView.connectAccountButton.elevate': 'Link to Elevate',
        'teams.webView.loggingOutHeader': 'Logging Out',
        'teams.webView.chrome.authorize': 'Connect to RecognitionNow Chrome Extension?',
        'teams.webView.chrome.authorize.connectedHeader': 'Welcome to RecognitionNow!',
        'teams.webView.chrome.authorize.connectedBody': 'You are ready to start using the RecognitionNow chrome extension.',
        'teams.webView.chrome.authorize.continue': 'Continue',
        'teams.webView.chrome.authorize.cancel': 'Cancel',
        'teams.webView.chrome.authorize.close': 'Close this window',
        'teams.webView.workplace.get-started': 'GET STARTED',
        'teams.webView.workplace.connect': 'Connect your account',
    },
    'es-ES': {},
    'es-MX': {},
    'fr-CA': {},
    'fr-FR': {},
    'id-ID': {},
    'it-IT': {},
    'ja-JP': {},
    'ko-KR': {},
    'nl-NL': {},
    'pl-PL': {},
    'pt-BR': {},
    'ru-RU': {},
    'th-TH': {},
    'tr-TR': {},
    'vi-VN': {},
    'zh-CN': {},
    'zh-TW': {}
};

/* A simple templating method based on Douglas Crockford's supplant. */
/* This method replaces all instances of the ${key} pattern with the */
/* corresponding key's value on the object passed into it. it also uses */
/* the pattern [key: text ${key} text] to signify repetition */
/* patterns. The inner text of the pattern is repeated N times, where N */
/* is the number of items at the key. A zero length array, null, */
/* undefined or empty string on the key removes the pattern entirely. */
/* Otherwise an array containing strings or objects gets applied */
/* recursively to the inner text pattern. */
/* https://gist.github.com/Breton/2497986 */
function supplant ( s, o ) {
    const tag = /\$\{([^}]*)\}/g;
    const many = /\[([a-zA-Z$_][a-zA-Z$_0-9]*?):([^\]]*)\]/g;

    function promote( v, b ) {
        let tmp;
        if ( typeof v !== 'object' ) {
            tmp = {};
            tmp[ b ] = v;
            v = tmp;
        }

        return v;
    }

    function rmany( a, b, c ) {
        let r = ( o[ b ] === 0 ? 0 : o[ b ] || [] ), i, set;
        r = promote( r, b );
        if ( typeof r.length !== 'number' ) {
            r = [ r ];
        }

        for ( i = 0, set = []; i < r.length; i += 1 ) {
            r[ i ] = promote( r[ i ], b );
            set[ i ] = c.template( r[ i ] );
        }

        return set.join( '' );
    }

    function rtag( a, b ) {
        const r = o[ b.trim() ];
        return typeof r === 'string' || typeof r === 'number' ? r : '';
    }

    return s.replace( many, rmany ).replace( tag, rtag );
}

let locale = localStorage.getItem( 'locale' ) || 'en-US';
export function getLocale() {
    return locale;
}
export function setLocale( value ) {
    locale = value;
    localStorage.setItem( 'locale', value );
}

export function getString( key, replacements = {} ) {
    let str = ( bundles[ locale ] || {} )[ key ];
    if ( str === undefined ) {
        str = ( bundles[ 'en-US' ] || {} )[ key ];
    }
    return supplant( str, replacements );
}
